import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { NIKE_API_HOST, DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import { BUY_PARTNER_CART_PREORDER } from '../constants';

/**
 * creates a paypal link to checkout with items in cart
 *
 * @param   {string} token - user authentication token
 * @property   {string} id paypal instruction identifier, user generated UUID
 * @property   {string} host Nike API domain host name
 * @property   {string} country getCapitalizedCountry from ux-tread-localization
 * @property   {string} language lang from geo
 * @property   {string} channel where paypal was initiated
 * @property   {string} cartId id of cart checked out
 * @property   {string} currency currency of geo
 * @property   {bool} paypalClicked determines if checkout via paypal
 * @property   {Array} items array of objects containing cart items
 * @property   {Array | undefined} experiments array of experiment variant strings
 * @returns {object} fetch client parsed json response or FetchResponseErrors
 */
export default function createPartnerCartPreorder(_ref) {
  var id = _ref.id,
    token = _ref.token,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    _ref$host = _ref.host,
    host = _ref$host === void 0 ? NIKE_API_HOST : _ref$host,
    country = _ref.country,
    language = _ref.language,
    channel = _ref.channel,
    cartId = _ref.cartId,
    currency = _ref.currency,
    paypalClicked = _ref.paypalClicked,
    items = _ref.items,
    _ref$appId = _ref.appId,
    appId = _ref$appId === void 0 ? DOTCOM_UX_ID : _ref$appId,
    cloudStack = _ref.cloudStack,
    _ref$experiments = _ref.experiments,
    experiments = _ref$experiments === void 0 ? undefined : _ref$experiments;
  return fetchClient("".concat(host, "/").concat(BUY_PARTNER_CART_PREORDER, "/").concat(id), {
    method: 'PUT',
    credentials: 'include',
    headers: _objectSpread({}, formatHeaders({
      token: token,
      visitId: visitId,
      visitorId: visitorId,
      appId: appId,
      cloudStack: cloudStack
    })),
    body: JSON.stringify({
      country: country,
      language: language,
      channel: channel,
      cartId: cartId,
      currency: currency,
      paypalClicked: paypalClicked,
      items: items,
      experiments: experiments
    })
  }, 'Error creating link to Partner Cart.', {
    pageActionName: 'tread-partnercart-event'
  });
}